import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { Table, Text, Tooltip } from '@nerdwallet/currency';
import { CreditScoreReception } from './CreditScoreReception';
import { getFicoLabelFrom } from '../lib/utils/FicoLabels';
import { LOA_CTA_TOOLTIP_LABEL } from '../lib/constants';
import "./CreditScoreWidget.styles.css";
export var CreditScoreWidget = function CreditScoreWidget(props) {
  var _classNames;

  var minLabel = getFicoLabelFrom(props.minFico);
  var maxLabel = getFicoLabelFrom(props.maxFico);
  var rangeWords = [];

  if (minLabel) {
    rangeWords.push(minLabel);
  }

  if (maxLabel && minLabel !== maxLabel) {
    rangeWords.push(maxLabel);
  }

  var chicletContent = [];

  if (rangeWords.length > 0) {
    chicletContent.push(rangeWords.join(' - '));
  }

  var recommendedCreditValue = rangeWords.join('_');

  if (props.limitedCreditHistory) {
    chicletContent.push('limited history');
    recommendedCreditValue += '_limited';
  }

  return /*#__PURE__*/React.createElement(Impression, {
    entityName: "recommended_cs",
    eventType: "recommended_credit_score_impression",
    payload: {
      additional_attributes: {
        recommended_score: recommendedCreditValue
      },
      section_name: props.analytics && props.analytics.sectionName,
      section_position: props.analytics && props.analytics.sectionPosition
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('credit_score__pill', (_classNames = {}, _defineProperty(_classNames, "+".concat(minLabel), minLabel), _defineProperty(_classNames, "+".concat(maxLabel), maxLabel), _defineProperty(_classNames, "+limited_history", props.limitedCreditHistory), _classNames))
  }, /*#__PURE__*/React.createElement("div", {
    className: "credit_score__pill__icon"
  }, /*#__PURE__*/React.createElement(CreditScoreReception, {
    reception: minLabel || maxLabel
  })), /*#__PURE__*/React.createElement("p", null, chicletContent.join(' or '))));
};
export var CreditScoreWidgetLabel = function CreditScoreWidgetLabel() {
  return /*#__PURE__*/React.createElement("div", null, "Recommended Credit", /*#__PURE__*/React.createElement(Tooltip, {
    className: "creditScoreTooltip",
    content: /*#__PURE__*/React.createElement("div", {
      className: "creditScoreTooltipContent"
    }, /*#__PURE__*/React.createElement("div", {
      className: "creditScoreTooltipText"
    }, /*#__PURE__*/React.createElement(Text, null, "Credit scores by range")), /*#__PURE__*/React.createElement(Table, {
      columns: [{
        heading: '',
        id: 'col1'
      }, {
        heading: 'Credit Score',
        id: 'col2'
      }],
      data: [{
        col1: /*#__PURE__*/React.createElement(Text, null, "Excellent"),
        col2: '720-850'
      }, {
        col1: /*#__PURE__*/React.createElement(Text, null, "Good"),
        col2: '690-719'
      }, {
        col1: /*#__PURE__*/React.createElement(Text, null, "Fair"),
        col2: '630-689'
      }, {
        col1: /*#__PURE__*/React.createElement(Text, null, "Bad"),
        col2: '300-629'
      }, {
        col1: /*#__PURE__*/React.createElement(Text, null, "Limited history"),
        col2: 'Less than three years of credit history'
      }]
    })),
    title: LOA_CTA_TOOLTIP_LABEL,
    placement: "bottom"
  }));
};